// @ts-strict-ignore
import { PermissionEnum } from "@dashboard/graphql";
import PermissionGroups from "@dashboard/icons/PermissionGroups";
import SiteSettings from "@dashboard/icons/SiteSettings";
import StaffMembers from "@dashboard/icons/StaffMembers";
import { sectionNames } from "@dashboard/intl";
import { marketplaceSettingsUrl } from "@dashboard/marketplaceSettings/urls";
import { permissionGroupListUrl } from "@dashboard/permissionGroups/urls";
import { refundsSettingsPath } from "@dashboard/refundsSettings/urls";
import { siteSettingsUrl } from "@dashboard/siteSettings/urls";
import { staffListUrl } from "@dashboard/staff/urls";
import { CreditCard, Percent } from "lucide-react";
import { type IntlShape } from "react-intl";

import { type MenuSection } from "./types";

export function createConfigurationMenu(intl: IntlShape): MenuSection[] {
  return [
    {
      label: intl.formatMessage({
        id: "UN+yTt",
        defaultMessage: "Staff Settings",
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            id: "RQUkVW",
            defaultMessage: "Manage your employees and their permissions",
          }),
          icon: <StaffMembers />,
          permissions: [PermissionEnum.MANAGE_STAFF],
          title: intl.formatMessage(sectionNames.staff),
          url: staffListUrl(),
          testId: "configuration-menu-staff",
        },
        {
          description: intl.formatMessage({
            id: "ivJ1qt",
            defaultMessage: "Manage your permission groups and their permissions",
          }),
          icon: <PermissionGroups />,
          permissions: [PermissionEnum.MANAGE_STAFF],
          title: intl.formatMessage(sectionNames.permissionGroups),
          url: permissionGroupListUrl(),
          testId: "configuration-menu-permission-groups",
        },
      ],
    },
    {
      label: intl.formatMessage({
        id: "YZl6cv",
        defaultMessage: "Miscellaneous",
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            id: "5BajZK",
            defaultMessage: "View and update your site settings",
          }),
          icon: <SiteSettings />,
          permissions: [PermissionEnum.MANAGE_SETTINGS],
          title: intl.formatMessage(sectionNames.siteSettings),
          url: siteSettingsUrl(),
          testId: "configuration-menu-site-settings",
        },
        {
          description: intl.formatMessage({
            id: "rUnw7n",
            defaultMessage: "Configure refunds behavior",
          }),
          icon: <CreditCard />,
          permissions: [PermissionEnum.MANAGE_SETTINGS],
          title: intl.formatMessage(sectionNames.refundsSettings),
          url: refundsSettingsPath,
          testId: "configuration-menu-refunds-settings",
        },
        {
          description: intl.formatMessage({
            id: "mktSet1",
            defaultMessage: "Default commission, GST, TDS and payout schedule",
          }),
          icon: <Percent />,
          permissions: [PermissionEnum.MANAGE_SELLERS],
          title: intl.formatMessage({
            id: "mktSet2",
            defaultMessage: "Marketplace settings",
          }),
          url: marketplaceSettingsUrl(),
          testId: "configuration-menu-marketplace-settings",
          fullWidth: true,
        },
      ],
    },
  ];
}
